export default __webpack_public_path__ + "static/media/10.dc8d832e.jpg";